import { createFileRoute } from '@tanstack/react-router';

import { ProtheusConfigPage } from '@/features/settings';

export const Route = createFileRoute('/app/settings/protheus')({
  component: ProtheusConfigPage,
});
